exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-amenities ul{position:relative}.amenity-item{-webkit-transition:.5s;transition:.5s;border-radius:20px;text-transform:uppercase;font-size:12px;letter-spacing:1px;font-weight:bolder;padding:5px 10px}.amenity-item:hover{cursor:pointer}.fadeLeft-move,.fadeRight-move{-webkit-transition:.75s;transition:.75s}.card-enter,.card-leave-to{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}.fadeLeft-leave-active,.fadeRight-leave-active{position:absolute;width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a9b392","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/unit/AddUnit.vue
// module id = 2hZ7
// module chunks = 0 1